import React, { Component } from "react";
import $ from "jquery";

class BasePage extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.store = {};
    this.storeName = "Nexoid";
    this.storeEncrypt = false;

    this.loadStore();
    this.setReferral();
    this.referral = this.getReferral();
    this.timer = {};
  }

  handleScroll(a) {
    if (typeof this.menuScroll === "function") {
      window.nexoidScrollBar.view.scrollTop = a.scrollTop;
      this.menuScroll(a.scrollTop);
    }
  }

  mountScrollbar(sb) {
    window.nexoidScrollBar = sb;
    window.nexoidScrollBarTop = this.nexoidScrollBarTop;
    window.nexoidScrollBarTopQuick = this.nexoidScrollBarTopQuick;
  }

  nexoidScrollBarTop(px) {
    if (typeof px !== "number") {
      px = 0;
    }
    window.nexoidScrollBar.view.scroll({
      top: px,
      left: 0,
      behavior: "smooth"
    });
  }
  nexoidScrollBarTopQuick(px) {
    if (typeof px !== "number") {
      px = 0;
    }
    window.nexoidScrollBar.view.scroll({
      top: px,
      left: 0
    });
  }

  componentWillUnmount() {
    var timers = Object.keys(this.timer);
    for (var i = 0; i < timers.length; i++) {
      if (this.timer[timers[i]] !== undefined) {
        clearTimeout(this.timer[timers[i]]);
      }
    }
  }

  getNexoidUrlQs() {
    if (this.referral === undefined || this.referral === "") {
      return "";
    } else {
      return "?referral=" + this.referral;
    }
  }

  setMeta(title, description) {
    document.title = title;
    $("meta[name=description]").remove();
    $("head").append('<meta name="description" content="' + description + '">');
  }

  setReferral() {
    var ref = this.getQueryString("referral");
    if (ref !== undefined) {
      this.store.Referral = {
        timestamp: new Date().getTime() + 10800000, // 3 hour
        code: ref
      };
      this.saveStore();
    }
  }

  getReferral() {
    if (typeof this.store.Referral === "object") {
      if (typeof this.store.Referral.timestamp === "number") {
        if (this.store.Referral.timestamp > new Date().getTime()) {
          return this.store.Referral.code;
        }
      }
    }
    return undefined;
  }

  setSkipIntro() {
    this.store.SkipIntro = {
      timestamp: new Date().getTime() + 3600000 // 1 hour
    };
    this.saveStore();
  }

  getSkipIntro() {
    if (typeof this.store.SkipIntro === "object") {
      if (typeof this.store.SkipIntro.timestamp === "number") {
        if (this.store.SkipIntro.timestamp > new Date().getTime()) {
          return true;
        }
      }
    }
    return false;
  }

  getQueryString(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  loadStore() {
    this.store = {};
    var s = localStorage.getItem(this.storeName);
    if (s !== null) {
      if (this.storeEncrypt === true) {
        try {
          s = this.decryptText(s);
        } catch (e) { }
      }
      try {
        this.store = JSON.parse(s);
      } catch (e) { }
    }
    this.saveStore();
  }

  getRandomString(length) {
    if (length === undefined) {
      length = 32;
    }
    var ret = "";
    var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      ret += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return ret;
  }

  saveStore() {
    var s = JSON.stringify(this.store);
    if (this.storeEncrypt === true) {
      try {
        s = this.encryptText(s);
      } catch (e) { }
    }
    localStorage.setItem(this.storeName, s);
  }

  encryptText(text, key) {
    const crypto = require("crypto");
    const iv = Buffer.from("50b9bc5c57597504423815d8605acb23", "hex");
    if (key === undefined) {
      key = Buffer.from(
        "84cbebefc068807a2627d9b88aed953078db000ca2e48904d802e62ca2b61282",
        "hex"
      );
    }
    let cipher = crypto.createCipheriv("aes-256-cbc", Buffer.from(key), iv);
    let encrypted = cipher.update(text);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return encrypted.toString("hex");
  }

  decryptText(text, key) {
    const crypto = require("crypto");
    const iv = Buffer.from("50b9bc5c57597504423815d8605acb23", "hex");
    if (key === undefined) {
      key = Buffer.from(
        "84cbebefc068807a2627d9b88aed953078db000ca2e48904d802e62ca2b61282",
        "hex"
      );
    }
    let encryptedText = Buffer.from(text, "hex");
    let decipher = crypto.createDecipheriv("aes-256-cbc", Buffer.from(key), iv);
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
  }
}

export default BasePage;



// WEBPACK FOOTER //
// ./src/components/Page/BasePage.js